import { container, leftCount, todoList } from "./elements";
import { initListEvetns } from "./eventListeners";

const addTaskToList = (task, checkIcon, crossIcon) => {
  let listItem = document.createElement("li");

  listItem.classList.add("todo__item");
  task.hide ? listItem.classList.add("todo__item--hide") : null;
  listItem.setAttribute("id", task.id);
  listItem.setAttribute("draggable", true);

  listItem.innerHTML += `
    <div class="todo__task ${
      task.isCompleted ? " todo__task--isCompleted" : ""
    }">
      <div class="icon check__icon" data-id="${
        task.id
      }" role="button" tabindex="0">
        <img src="${checkIcon}" alt="check icon" />
      </div>
      <span>${task.value}</span>
    </div>
    <div class="delete__icon">
      <img src="${crossIcon}" alt="cross icon" class="icon cross__icon" data-id="${
    task.id
  }" role="button" tabindex="0" />
      <svg fill="#000000" width="20px" height="20px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M10,4A2,2,0,1,1,8,2,2,2,0,0,1,10,4ZM8,10a2,2,0,1,0,2,2A2,2,0,0,0,8,10Zm0,8a2,2,0,1,0,2,2A2,2,0,0,0,8,18ZM16,6a2,2,0,1,0-2-2A2,2,0,0,0,16,6Zm0,8a2,2,0,1,0-2-2A2,2,0,0,0,16,14Zm0,8a2,2,0,1,0-2-2A2,2,0,0,0,16,22Z"></path></g></svg>
    </div>
  `;

  todoList.appendChild(listItem);
};

export const getData = (item) => {
  return localStorage.getItem(item);
};

export const saveData = (key, data) => {
  localStorage.setItem(key, JSON.stringify(data));
};

export const addNewTodo = (task, tasksList) => {
  tasksList.push(task);
  saveData("tasksList", tasksList);
  return tasksList;
};

export const updateTodoList = (data) => {
  todoList.innerHTML = "";
  let currentDisplay = JSON.parse(getData("currentDisplay")) || "all";
  const activeCount = JSON.parse(getData("activeCount")) || 0;
  const completedCount = JSON.parse(getData("completedCount")) || 0;

  if (data.length) {
    if (currentDisplay === "active" && activeCount === 0) {
      todoList.innerHTML = `<li class="todo__item">No Active Tasks (All Tasks Completed)</li>`;
      return;
    } else if (currentDisplay === "completed" && completedCount === 0) {
      todoList.innerHTML = `<li class="todo__item">No Completed Tasks (All Tasks Active)</li>`;
      return;
    } else {
      const checkIcon = new URL(
        "/assets/images/icon-check.svg",
        import.meta.url
      );

      const crossIcon = new URL(
        "/assets/images/icon-cross.svg",
        import.meta.url
      );

      data
        .sort((a, b) => a.order - b.order)
        .forEach((item) => addTaskToList(item, checkIcon, crossIcon));
    }
  } else {
    todoList.innerHTML += `<li class="todo__item">ToDo List Is Empty</li>`;
  }

  leftCount.textContent = JSON.parse(getData("activeCount")) || 0;

  initListEvetns();
};

export const toggleTheme = () => container.classList.toggle("theme--isDark");

export const initDataOnStartup = () => {
  const tasksList = JSON.parse(getData("tasksList")) || [];
  const isDarkTheme = JSON.parse(getData("isDarkTheme"));

  isDarkTheme && toggleTheme();
  updateTodoList(tasksList);
};
